import { useNavigate } from 'react-router-dom';
import { Api, apiCall, getDefaultLanguage, getFormData } from '../../services';
import { setCalculationResponse, setChartIndex, setClientMotorResponse, setLanguage, setMesRequest, toggleLoading } from '../../store';
import { ClientMotorRequest } from '../../models/ClientMotorRequest';
import { useAppDispatch } from '../common';
import saveAs from 'file-saver';

export const useTestPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (motorRequest: object) => {
        dispatch(toggleLoading());

        const formData = getFormData(motorRequest);

        await apiCall(
            Api.getConfiguration(formData),
            async x => {
                const clientMotorRequest = JSON.parse(`${x.data.clientMotorRequest}`);

                dispatch(setChartIndex(0));
                dispatch(setCalculationResponse(undefined));
                dispatch(setMesRequest(x.data.motorRequest));
                dispatch(setClientMotorResponse({
                    motorRequest: x.data.motorRequest,
                    clientMotorRequest
                }));
                dispatch(setLanguage(getDefaultLanguage(clientMotorRequest.JOM_LANG || clientMotorRequest.LANG)));

                // Navigate to spcRequest page to show the results
                navigate('/spcRequest');
            },
            async () => { }
        );

        dispatch(toggleLoading());
    };

    const getClientDocument = async (motorRequest: ClientMotorRequest) => {
        dispatch(toggleLoading());

        await apiCall(
            Api.getClientDocument(motorRequest),
            async x => saveAs(x),
            async () => {}
        );

        dispatch(toggleLoading());
    };

    return {
        onSubmit: handleSubmit,
        getClientDocument
    };
};
